import { Component, inject, signal } from '@angular/core';
import { ThemeService } from './core/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('ask-mila-app');
  // Created here, not lazily by the sidebar, so the stored theme is on
  // <html> before login/signup (no sidebar) render too.
  private readonly theme = inject(ThemeService);
}
